/* CP — fiche produit : galerie, quantité, variante, boutons de pointure arrondis, ligne de stock */
(function(){
  var SEUIL_BAS = 5;

  /* Aperçu design (thème non publié uniquement) : ?stock_preview=1 pour activer, ?stock_preview=0 pour couper.
     Fonctionne sur toutes les fiches produit et reste actif pendant la session.
     En aperçu, le nombre de personnes monte et les pointures baissent (jamais à zéro) pendant que la page reste ouverte (simulation). */
  var PREVIEW = 0;
  try{
    var role = (window.Shopify && Shopify.theme && Shopify.theme.role) || 'main';
    if(role !== 'main'){
      var raw = new URLSearchParams(location.search).get('stock_preview');
      if(raw !== null){
        if(parseInt(raw,10) > 0){ sessionStorage.setItem('cp_stock_preview','1'); }
        else {
          sessionStorage.removeItem('cp_stock_preview');
          for(var k=sessionStorage.length-1;k>=0;k--){ var kn=sessionStorage.key(k); if(kn && kn.indexOf('cp_pv_s_')===0) sessionStorage.removeItem(kn); }
        }
      }
      if(sessionStorage.getItem('cp_stock_preview') === '1') PREVIEW = 1;
    }
  }catch(e){}
  var PQ = [4,2,3,5,1,2,4,3,5,2,1,4,3,2,5,1,3,4];
  var PS = null, PKEY = '', pvSave = function(){};
  var pq = function(i){ return (PREVIEW && PS && PS.q[i]) ? PS.q[i] : 0; };

  var gal=document.querySelector('.pgal');
  var main=document.getElementById('pMain');

  if(gal && main){
    gal.addEventListener('click', function(e){
      var b=e.target.closest('.pt[data-src]');
      if(!b) return;
      e.preventDefault();
      e.stopPropagation();
      var t=gal.querySelectorAll('.pt');
      for(var i=0;i<t.length;i++) t[i].classList.remove('on');
      b.classList.add('on');
      main.src=b.getAttribute('data-src');
    }, true);

    document.addEventListener('keydown', function(e){
      if(e.key!=='ArrowLeft' && e.key!=='ArrowRight') return;
      var z=document.querySelector('.cpz.on'); if(z) return;
      var tag=(e.target.tagName||'').toLowerCase();
      if(tag==='input' || tag==='textarea' || tag==='select') return;
      var t=[].slice.call(gal.querySelectorAll('.pt[data-src]'));
      if(t.length<2) return;
      var k=0;
      for(var i=0;i<t.length;i++){ if(t[i].classList.contains('on')) k=i; }
      k=(k+(e.key==='ArrowRight'?1:-1)+t.length)%t.length;
      t[k].click();
    });
  }

  var slides=document.getElementById('pSlides'), dots=document.getElementById('pDots');
  if(slides && dots && slides.children.length > 1){
    var tmr=null;
    var upd=function(){
      var first=slides.children[0];
      var step=first ? first.getBoundingClientRect().width + 10 : slides.clientWidth;
      if(step < 1) return;
      var i=Math.round(slides.scrollLeft/step);
      var d=dots.children;
      if(i<0) i=0;
      if(i>d.length-1) i=d.length-1;
      for(var k=0;k<d.length;k++) d[k].classList.toggle('on', k===i);
    };
    slides.addEventListener('scroll', function(){
      clearTimeout(tmr);
      tmr=setTimeout(upd, 70);
    }, {passive:true});
    window.addEventListener('resize', upd, {passive:true});
  }

  var qw=document.querySelector('.qty');
  if(qw){
    var inp=qw.querySelector('input');
    qw.addEventListener('click', function(e){
      var b=e.target.closest('[data-q]');
      if(!b || !inp) return;
      e.preventDefault();
      var v=parseInt(inp.value,10); if(isNaN(v)) v=1;
      v+=parseInt(b.getAttribute('data-q'),10)||0;
      if(v<1) v=1;
      if(v>99) v=99;
      inp.value=v;
    });
  }

  var sel=document.getElementById('vSel'),
      price=document.getElementById('pPrice'),
      stock=document.getElementById('pStock'),
      chips=document.getElementById('vChips');

  /* APERÇU : état simulé par produit, gardé pendant la session */
  var handle=(location.pathname.split('/products/')[1]||'').split('/')[0];
  var h=0; for(var c=0;c<handle.length;c++){ h=(h*31+handle.charCodeAt(c))>>>0; }
  var vn=null;
  if(PREVIEW && sel){
    PKEY='cp_pv_s_'+handle;
    try{ PS=JSON.parse(sessionStorage.getItem(PKEY)||'null'); }catch(e){ PS=null; }
    var nopt=sel.options.length;
    if(!PS || !PS.q || PS.q.length!==nopt){
      PS={v:38+h%110, nw:0, q:[]};
      for(var qi=0;qi<nopt;qi++) PS.q.push(PQ[qi%PQ.length]);
    }
    pvSave=function(){ try{ sessionStorage.setItem(PKEY, JSON.stringify(PS)); }catch(e){} };
    pvSave();
  }

  var line=null, lTxt=null, lSub=null;
  if(stock){
    var st=document.createElement('style');
    st.textContent='.stkline{display:flex;align-items:center;gap:8px;margin:12px 0 4px;padding:10px 0;border-top:1px solid #e5e5e5;border-bottom:1px solid #e5e5e5;font-size:15px;max-width:420px}'+
      '.stkline .stkdot{width:9px;height:9px;border-radius:50%;background:#2fbf71;flex:none}'+
      '.stkline.low .stkdot{animation:stkpulse 1.6s ease-out infinite}'+
      '@keyframes stkpulse{0%{box-shadow:0 0 0 0 rgba(47,191,113,.65)}70%{box-shadow:0 0 0 9px rgba(47,191,113,0)}100%{box-shadow:0 0 0 0 rgba(47,191,113,0)}}'+
      '@keyframes stklive{0%{box-shadow:0 0 0 0 rgba(229,57,53,.6)}70%{box-shadow:0 0 0 8px rgba(229,57,53,0)}100%{box-shadow:0 0 0 0 rgba(229,57,53,0)}}'+
      '@media (prefers-reduced-motion:reduce){.stkline.low .stkdot,.stkview .live{animation:none!important}}'+
      '.stkline b{font-weight:700;color:#111}'+
      '.stkline em{font-style:normal;color:#9a9a9a;font-size:13px}'+
      '.stkline.out .stkdot{background:#c0392b}'+
      '#pStock{display:none!important}'+
      '#vChips{display:grid!important;grid-template-columns:repeat(5,minmax(0,1fr))!important;gap:8px!important}'+
      '#vChips .chip{position:relative;width:auto!important;min-width:0!important;height:52px;padding:0 4px!important;border-radius:14px!important;display:flex;align-items:center;justify-content:center;text-align:center;font-size:14px;line-height:1.1;border:1px solid #d6d6d6;background:#fff;transition:border-color .15s}'+
      '#vChips .chip:hover{border-color:#111}'+
      '#vChips .chip.on{border:2px solid #111}'+
      '#vChips .chip.off{opacity:.4;text-decoration:line-through}'+
      '#vChips .chip .cq{position:absolute;top:-7px;right:-5px;min-width:20px;height:20px;border-radius:10px;background:#c2410c;color:#fff;font-size:11px;font-weight:700;display:flex;align-items:center;justify-content:center;padding:0 5px;box-shadow:0 0 0 2px #fff}'+
      '.cqleg{font-size:12px;color:#777;margin:10px 0 0}.cqleg i{display:inline-block;width:10px;height:10px;border-radius:50%;background:#c2410c;vertical-align:-1px;margin-right:5px}'+
      '.stkview{display:flex;align-items:center;gap:7px;margin:4px 0 2px;font-size:13.5px;color:#444}'+
      '.stkview .live{width:8px;height:8px;border-radius:50%;background:#e53935;flex:none;animation:stklive 1.6s ease-out infinite}'+
      '.stkprev{font-size:10px;background:#fff3cd;color:#7a5b00;padding:1px 6px;border-radius:8px;margin-left:4px}';
    document.head.appendChild(st);
    line=document.createElement('div');
    line.className='stkline';
    line.innerHTML='<i class="stkdot"></i><b></b><em></em>';
    lTxt=line.querySelector('b'); lSub=line.querySelector('em');
    var prow=stock.closest('.prow');
    if(prow && prow.parentNode) prow.parentNode.insertBefore(line, prow.nextSibling);

    /* APERÇU DESIGN UNIQUEMENT : visiteurs simulés (jamais sur le thème publié) */
    if(PREVIEW && PS){
      var vw=document.createElement('div');
      vw.className='stkview';
      vw.innerHTML='<i class="live"></i><span><b class="vn"></b> regardent cette page</span><span class="stkprev">aperçu</span>';
      vn=vw.querySelector('.vn');
      vn.textContent=PS.v+' personnes';
      line.parentNode.insertBefore(vw, line.nextSibling);
      try{
        fetch('/collections/nouveautes-1/products.json?limit=250').then(function(r){return r.json();}).then(function(j){
          var isNew=(j.products||[]).some(function(p){return p.handle===handle;});
          if(isNew && !PS.nw){ PS.nw=1; PS.v += (157+h%144)-(38+h%110); vn.textContent=PS.v+' personnes'; pvSave(); }
        }).catch(function(){});
      }catch(e){}
    }
  }

  var chipBadges=function(){
    if(!sel||!chips) return;
    var bs=chips.querySelectorAll('.chip'), n=0;
    for(var i=0;i<sel.options.length && i<bs.length;i++){
      var o=sel.options[i];
      var q=parseInt(o.getAttribute('data-qty'),10);
      if(pq(i)>0) q=pq(i);
      if(o.getAttribute('data-av')==='true' && !isNaN(q) && q>0 && q<=SEUIL_BAS){
        var s=document.createElement('span');
        s.className='cq';
        s.textContent=q;
        s.title=q===1?'1 paire restante':q+' paires restantes';
        bs[i].appendChild(s);
        n++;
      }
    }
    if(n){
      var lg=document.createElement('p');
      lg.className='cqleg';
      lg.innerHTML='<i></i>Le chiffre en rouge indique le nombre de paires restantes.';
      chips.parentNode.insertBefore(lg, chips.nextSibling);
    }
  };
  chipBadges();

  if(sel){
    var sync=function(){
      var o=sel.options[sel.selectedIndex];
      if(!o) return;
      if(price && o.getAttribute('data-price')) price.textContent=o.getAttribute('data-price');

      if(stock){
        var av=o.getAttribute('data-av')==='true';
        var q=parseInt(o.getAttribute('data-qty'),10);
        var p=pq(sel.selectedIndex);
        if(av && p>0) q=p;
        var txt, sub='';
        var low = av && !isNaN(q) && q>0 && q<=SEUIL_BAS;
        if(!av){ txt='Victime de son succès'; }
        else if(low){ txt='Plus que '+q+' en stock'; sub='· Bientôt épuisé'; }
        else { txt='En stock'; }
        stock.textContent=txt;
        stock.classList.toggle('in',av);
        stock.classList.toggle('low', low);
        if(line){
          lTxt.textContent=txt;
          lSub.textContent=sub;
          line.classList.toggle('out', !av);
          line.classList.toggle('low', low);
        }
      }

      if(chips){
        var bs=chips.querySelectorAll('.chip');
        for(var i=0;i<bs.length;i++){
          bs[i].classList.toggle('on', bs[i].getAttribute('data-id')===sel.value);
        }
      }

      try{
        var u=new URL(location.href);
        u.searchParams.set('variant', sel.value);
        history.replaceState({},'',u);
      }catch(err){}
    };

    sel.addEventListener('change', sync);

    if(chips){
      chips.addEventListener('click', function(e){
        var b=e.target.closest('.chip');
        if(!b || b.disabled) return;
        e.preventDefault();
        sel.value=b.getAttribute('data-id');
        sel.dispatchEvent(new Event('change',{bubbles:true}));
      });
    }

    sync();

    /* APERÇU DESIGN UNIQUEMENT : évolution simulée pendant que la page reste ouverte */
    if(PREVIEW && PS){
      setInterval(function(){
        if(!vn) return;
        if(PS.v < 999) PS.v += 1 + Math.floor(Math.random()*3);
        vn.textContent = PS.v + ' personnes';
        pvSave();
      }, 7000);
      setInterval(function(){
        var cand=[];
        for(var i=0;i<PS.q.length;i++){
          var op=sel.options[i];
          if(op && op.getAttribute('data-av')==='true' && PS.q[i]>1) cand.push(i);
        }
        if(!cand.length) return;
        var k=cand[Math.floor(Math.random()*cand.length)];
        PS.q[k]--;
        var bs=chips ? chips.querySelectorAll('.chip') : [];
        if(bs[k]){
          var cq=bs[k].querySelector('.cq');
          if(cq){ cq.textContent=PS.q[k]; cq.title=PS.q[k]===1?'1 paire restante':PS.q[k]+' paires restantes'; }
        }
        if(k===sel.selectedIndex) sync();
        pvSave();
      }, 12000);
    }
  }
})();

/* CP — Avis clients façon Nike : accordéon « Avis (N) ★★★★★ » juste sous Paiement sécurisé, avec photos et notes visibles direct */
(function(){
  var css='html body .jm-star-rating__font-icon,html body .pdp.u .pinf .jm-star-rating__font-icon,html body .jdgm-star,html body .pdp.u .pinf .jdgm-star{font-family:JudgemeStar,monospace!important}'+
    'details.pacc-avis summary{display:flex;align-items:center;gap:12px}'+
    'details.pacc-avis .cpav-st{display:inline-flex;gap:2px;margin-left:auto;margin-right:28px}'+
    'details.pacc-avis .cpav-st svg{width:17px;height:17px;fill:#108474}'+
    'details.pacc-avis .cpav-st svg.off{fill:#d4d4d4}'+
    'details.pacc-avis .cpav-body{padding:4px 0 16px}'+
    'details.pacc-avis .jm-review-widget-minimal-header__title{display:none}'+
    'details.pacc-avis .jm-media-thumbnail-list__thumbnail{width:84px!important;height:84px!important;min-width:0!important;border-radius:8px;overflow:hidden}'+
    'details.pacc-avis .jm-media-grid__image-container{border-radius:8px;overflow:hidden}';
  var st=document.createElement('style'); st.textContent=css; document.head.appendChild(st);
  var w=document.getElementById('judgeme_product_reviews'), pinf=document.querySelector('.pinf');
  if(!w || !pinf || document.querySelector('.pacc-avis')) return;
  var bd=document.querySelector('.jdgm-prev-badge');
  var n=+((bd && bd.getAttribute('data-number-of-reviews'))||0), avg=+((bd && bd.getAttribute('data-average-rating'))||0);
  var s='';
  for(var i=1;i<=5;i++) s+='<svg viewBox="0 0 24 24"'+(avg>=i-0.25?'':' class="off"')+'><path d="M12 2l2.9 6.9 7.1.6-5.4 4.7 1.7 7-6.3-3.9-6.3 3.9 1.7-7L2 9.5l7.1-.6z"/></svg>';
  var d=document.createElement('details');
  d.className='pacc pacc-avis'; d.id='avis';
  d.innerHTML='<summary><span>Avis ('+n+')</span>'+(n?'<span class="cpav-st" aria-label="'+avg.toFixed(1)+' sur 5">'+s+'</span>':'')+'</summary><div class="cpav-body"></div>';
  d.open=true;
  var place=function(){
    var rs=pinf.querySelector(':scope > .cfp-rs'), tr=pinf.querySelector(':scope > .ptrust');
    if(rs) rs.parentNode.insertBefore(d, rs.nextSibling);
    else if(tr) tr.parentNode.insertBefore(d, tr);
    else { var accs=pinf.querySelectorAll(':scope > details.pacc'); if(accs.length) accs[accs.length-1].parentNode.insertBefore(d, accs[accs.length-1].nextSibling); else pinf.appendChild(d); }
    return !!rs;
  };
  if(!place()){ var tries=0, iv=setInterval(function(){ if(place() || ++tries>20) clearInterval(iv); }, 250); }
  d.querySelector('.cpav-body').appendChild(w);
  var old=document.querySelector('.cp-avis'); if(old) old.style.display='none';
  var badge=document.querySelector('.pinf .jdgm-preview-badge');
  if(badge) badge.addEventListener('click', function(){ d.open=true; setTimeout(function(){ d.scrollIntoView({behavior:'smooth',block:'start'}); },30); });
})();
/* CP — Avis en carrousel : cartes qui défilent de gauche à droite avec flèches */
(function(){
  var body=document.querySelector('.pacc-avis .cpav-body');
  if(!body) return;
  var css='details.pacc-avis .cpav-body{position:relative}'+
    'details.pacc-avis .jdgm-review-list{display:flex!important;flex-direction:row!important;gap:12px!important;overflow-x:auto;scroll-snap-type:x mandatory;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;scrollbar-width:none;padding:2px 2px 8px}'+
    'details.pacc-avis .jdgm-review-list::-webkit-scrollbar{display:none}'+
    'details.pacc-avis .jdgm-review-list>.jm-review-item{flex:0 0 82%;max-width:300px;scroll-snap-align:start;border:1px solid #e5e5e5;border-radius:14px;padding:14px!important;margin:0!important;box-sizing:border-box;background:#fff}'+
    'details.pacc-avis .jdgm-review-list>.jm-review-item .jm-media-thumbnail-list__thumbnail{width:56px!important;height:56px!important}'+
    'details.pacc-avis .jdgm-review-list>.jm-review-item .jm-review-content{display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;overflow:hidden}'+
    'details.pacc-avis .jm-media-grid{display:none!important}'+
    '.cpav-nav{position:absolute;z-index:3;width:38px;height:38px;border-radius:50%;border:1px solid #e5e5e5;background:#fff;box-shadow:0 2px 8px rgba(0,0,0,.12);display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;transform:translateY(-50%)}'+
    '.cpav-nav svg{width:16px;height:16px;stroke:#111;fill:none;stroke-width:2.2}'+
    '.cpav-nav[hidden]{display:none!important}.cpav-prev{left:-12px}.cpav-next{right:-12px}';
  var st=document.createElement('style'); st.textContent=css; document.head.appendChild(st);
  var mk=function(cls,lab,path){
    var b=document.createElement('button'); b.type='button'; b.className='cpav-nav '+cls; b.setAttribute('aria-label',lab); b.hidden=true;
    b.innerHTML='<svg viewBox="0 0 24 24"><path d="'+path+'"/></svg>'; body.appendChild(b); return b;
  };
  var pv=mk('cpav-prev','Avis précédent','M15 5l-7 7 7 7'), nx=mk('cpav-next','Avis suivant','M9 5l7 7-7 7');
  var list=function(){ return body.querySelector('.jdgm-review-list'); };
  var step=function(l){ var it=l.querySelector('.jm-review-item'); return it ? it.getBoundingClientRect().width+12 : l.clientWidth; };
  var upd=function(){
    var l=list();
    if(!l || !l.offsetParent){ pv.hidden=nx.hidden=true; return; }
    var br=body.getBoundingClientRect(), lr=l.getBoundingClientRect();
    pv.style.top=nx.style.top=((lr.top-br.top)+lr.height/2)+'px';
    var max=l.scrollWidth-l.clientWidth;
    pv.hidden=l.scrollLeft<=4; nx.hidden=l.scrollLeft>=max-4;
    if(!l.__cp){ l.__cp=1; l.addEventListener('scroll',upd,{passive:true}); }
  };
  pv.addEventListener('click',function(){ var l=list(); if(l) l.scrollBy({left:-step(l),behavior:'smooth'}); });
  nx.addEventListener('click',function(){ var l=list(); if(l) l.scrollBy({left:step(l),behavior:'smooth'}); });
  upd(); setInterval(upd,800); window.addEventListener('resize',upd);
})();
/* CP — 5 étoiles vertes à côté de « 5.0 · N avis » dans l'en-tête des avis */
(function(){
  var bd=document.querySelector('.jdgm-prev-badge');
  var avg=+((bd && bd.getAttribute('data-average-rating'))||0);
  if(!avg) return;
  var st=document.createElement('style');
  st.textContent='.cpav-hst{display:inline-flex;gap:2px;align-items:center;margin:0 2px}.cpav-hst svg{width:16px;height:16px;fill:#108474}.cpav-hst svg.off{fill:#d4d4d4}';
  document.head.appendChild(st);
  var s='';
  for(var i=1;i<=5;i++) s+='<svg viewBox="0 0 24 24"'+(avg>=i-0.25?'':' class="off"')+'><path d="M12 2l2.9 6.9 7.1.6-5.4 4.7 1.7 7-6.3-3.9-6.3 3.9 1.7-7L2 9.5l7.1-.6z"/></svg>';
  var put=function(){
    var c=document.querySelector('.pacc-avis .jm-average-rating-display .jm-cluster');
    if(!c || c.querySelector('.cpav-hst') || !c.firstElementChild) return;
    var sp=document.createElement('span'); sp.className='cpav-hst'; sp.setAttribute('aria-hidden','true'); sp.innerHTML=s;
    c.insertBefore(sp, c.firstElementChild.nextSibling);
  };
  put(); setInterval(put,800);
})();
/* CP — Titre du bloc avis : « 5.0 ★★★★★ N avis » au lieu de « Avis (N) » */
(function(){
  var d=document.querySelector('.pacc-avis'); if(!d) return;
  var bd=document.querySelector('.jdgm-prev-badge');
  var n=+((bd && bd.getAttribute('data-number-of-reviews'))||0), avg=+((bd && bd.getAttribute('data-average-rating'))||0);
  var sm=d.querySelector('summary'); if(!sm) return;
  var st=document.createElement('style');
  st.textContent='details.pacc-avis summary .cpav-avg{font-weight:700;font-size:20px;color:#111}'+
    'details.pacc-avis summary .cpav-st{margin-left:4px!important;margin-right:0!important}'+
    'details.pacc-avis summary .cpav-n{font-size:14px;color:#555;margin-right:auto}'+
    'details.pacc-avis .jm-average-rating-display{display:none!important}';
  document.head.appendChild(st);
  var stars=sm.querySelector('.cpav-st');
  sm.innerHTML='';
  if(n){
    sm.insertAdjacentHTML('beforeend','<span class="cpav-avg">'+avg.toFixed(1)+'</span>');
    if(stars) sm.appendChild(stars);
    sm.insertAdjacentHTML('beforeend','<span class="cpav-n">'+n+' avis</span>');
  } else {
    sm.insertAdjacentHTML('beforeend','<span class="cpav-n">Aucun avis pour le moment</span>');
  }
})();
